import { AddToCalendarButton } from 'add-to-calendar-button-react';
import { useMainContext } from '@contexts/MainContext';

const AddToCalButton = ({ data, customDays = [] }) => {
	const { selectedDay } = useMainContext().state;

	const {
		time_start_24: timeStart = false,
		time_end_24: timeEnd = false,
		title = '',
		custom_venue: CustomVenue = '',
		taxonomies: { days = [], venues = [] },
		timezone = { value: 'Europe/Berlin' },
	} = data;

	let venue = '';

	if (!CustomVenue && venues.length > 0) {
		let count = 0;
		for (let item of venues) {
			count++;
			const separator =
				venues.length > 0 && venues.length !== count ? ' | ' : '';
			venue += `${item.name}`;
			venue += item.location ? ` - (${item.location})` : '';
			venue += separator;
		}
	} else if (CustomVenue) {
		venue = CustomVenue;
	}

	let theDay;

	// If we have custom days, use the first one.
	if (customDays && customDays?.length > 0) {
		theDay = customDays[0];
	} else {
		theDay = days.find((day) => day.term_id === parseInt(selectedDay[0]));
	}

	const year = new Date().getFullYear();
	const month = theDay && 0 !== theDay.month_nr ? theDay.month_nr : '';
	const day = theDay && 0 !== theDay.day_nr ? theDay.day_nr : '';

	const calendarDate = `${year}-${month}-${day}`;

	/*
	 * https://add-to-calendar-button.com/en/advanced-use#1
	 */
	return (
		<AddToCalendarButton
			label={'Add to calendar'}
			hideRichData={true}
			hideBranding={true}
			name={title}
			options={['Apple', 'Google', 'Microsoft365', 'Outlook.com', 'iCal']}
			location={venue}
			startDate={calendarDate}
			endDate={calendarDate}
			startTime={timeStart}
			endTime={timeEnd}
			timeZone={timezone.value}
			buttonStyle="default"
			size={3}
			hideTextLabelButton
			hideIconButton={false}
			styleLight="--btn-shadow: none;"
			styleDark="--btn-shadow: none;"
		/>
	);
};

export default AddToCalButton;
